/* Copyright (c) 2020-present CloudIO Inc */

/* eslint-disable import/no-mutable-exports */

let PLATFORM: number | symbol = 0xceb7;
let STORE: number | symbol = 0xceb8;

if (typeof Symbol === 'function' && Symbol.for) {
  const symbolFor = Symbol.for;
  PLATFORM = symbolFor('io.platform');
  STORE = symbolFor('io.platform');
}

export { STORE, PLATFORM };
